import { IOfferSpendCrudModalLang } from '../../../types/lang'

export const offerSpendCrudModalLang: IOfferSpendCrudModalLang = {
	offer_spend_crud_modal: {
		title_create: 'Create offer spend_ru',
		title_edit: 'Edit offer spend_ru',
		title_remove_single: 'Remove <span>offer spend_ru</span>',
		title_notes_view: 'View notes for offer spend_ru',
		title_notes_edit: 'Edit notes for offer spend_ru',
		title_history_view: 'View history in offer spend_ru',
		title_by_account: 'View offer spend detail info by account {{account}} - {{date}}_ru',
		title_by_account_total: 'View TOTAL offer spend detail info - {{date}}_ru',
		title_by_offer: 'View offer spend detail info by offer {{offer}} - {{date}}_ru',
		title_by_offer_total: 'View TOTAL offer spend detail info - {{date}}_ru',
		title_by_offer_scope: 'View offer spend detail info by offer scope {{offerScope}} - {{date}}_ru',
		title_by_offer_scope_total: 'View TOTAL offer spend detail info - {{date}}_ru',
		field_offer_label: 'Offer_ru',
		field_offer_placeholder: 'Offer_ru',
		field_user_label: 'User_ru',
		field_user_placeholder: 'User_ru',
		field_date_label: 'Date_ru',
		field_date_placeholder: 'Date_ru',
		field_amount_label: 'Amount_ru',
		field_amount_placeholder: 'Type number_ru',
		field_notes_label: 'Notes_ru',
		field_notes_placeholder: 'Notes_ru',
		msg_remove_confirm: 'Are you sure?_ru',
		btn_create: 'Create_ru',
		btn_update: 'Save_ru',
		btn_remove: 'Remove_ru',
		btn_close: 'Close_ru'
	}
}